import { Checkbox, FormControlLabel } from "@material-ui/core";
import React, { ChangeEvent, FC, useRef } from "react";
import { Measure } from "utils/api";
import { getMeasureLabel } from "utils/misc";
import styles from "./MeasureItem.module.scss";

interface Props {
  measure: Measure;
  isChecked: boolean;
  handleChange?(event: ChangeEvent<HTMLInputElement>): void;
}

const MeasureItem: FC<Props> = ({ measure, isChecked, handleChange }) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div ref={ref} className={styles.container} style={{ cursor: isChecked ? "move" : "", opacity: 1 }}>
      <FormControlLabel
        key={measure.id}
        className={styles.measuresLabel}
        control={<Checkbox onChange={handleChange} checked={isChecked} name={measure.id} />}
        label={getMeasureLabel(measure)}
      />
    </div>
  );
};

export default MeasureItem;
